import { fromJS } from 'immutable';
import { createReducer } from '../../../utils';
import { composeResetReducer } from 'redux-reset-store';
import {
    changeSubscriptionStep,
    clearSubscriptionData,
    saveReceivers,
    selectSubscriptionType,
    updateReceivers,
} from '../new/actions';

const initialState = {
    isLoading: false,
    items: {},
    newSubscription: {
        step: 0,
        selectedType: null,
        duration: '1',
        members: [
            {
                email: '',
            },
        ],
    },
};

export default composeResetReducer(
    createReducer(fromJS(initialState), {
        ['SUBSCRIPTIONS_FETCHSUBSCRIPTIONS_SUCCESS']: (state, payload) => state,
        [clearSubscriptionData]: (state, payload) => {
            return state.setIn(['newSubscription'], fromJS(initialState.newSubscription));
        },
        [selectSubscriptionType]: (state, payload) =>
            state.mergeIn(['newSubscription'], {
                selectedType: payload.identifier,
                amount: payload.amount,
                planId: payload.identifier,
                planVariantId: payload.plan_variant_id,
                step: 1,
                paymentPeriod: payload.payment_period,
            }),
        [changeSubscriptionStep]: (state, payload) =>
            state.mergeIn(['newSubscription'], { step: payload }),
        [updateReceivers]: (state, payload) =>
            state.setIn(['newSubscription', 'members'], fromJS(payload)),
        [saveReceivers]: (state, payload) =>
            state
                .setIn(['newSubscription', 'members'], fromJS(payload))
                .mergeIn(['newSubscription'], { step: 2 }),
    }),
    fromJS(initialState),
    'AUTH_LOGOUTUSER_REQUEST'
);
